import useQualityInspectionRepository from "../../../../repository/emergency/useQualityInspectionRepository";
import {useEffect} from "react";
import QualityInspection from "../../../../entity/emergency/QualityInspection";
import StepAppointment from "./step/appointment/StepAppointment";
import isNull from "../../../../mixin/isNull";
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";
import StepTravel from "./step/travel/StepTravel";
import StepPictureBefore from "./step/picture-before/StepPictureBefore";
import StepQuotation from "./step/quotation/StepQuotation";
import SubStepToValidate from "./step/client-signature/to-validate/SubStepToValidate";
import StepClientSignature from "./step/client-signature/StepClientSignature";
import StepWork from "./step/work/StepWork";
import UpdateQuotation from "./update-quotation/UpdateQuotation";
import StepPictureAfter from "./step/picture-after/StepPictureAfter";
import StepDelivery from "./step/delivery/StepDelivery";
import Terminate from "./step/terminate/Terminate";

export default function ({
                             qualityInspectionId,
                             clientId,
                             interventionId,
                             orderId,
                             updateQuotation,
                             onQuotationUpdated
                         }) {
    const qualityInspectionRepository = useQualityInspectionRepository();
    /** @type QualityInspection */
    const qualityInspection = qualityInspectionRepository.findOneById(qualityInspectionId).select();

    useEffect(() => {
        qualityInspectionRepository.findOneById(qualityInspectionId).exec();
    }, []);

    const getStep = () => {
        if (updateQuotation) {
            return <UpdateQuotation
                qualityInspectionId={qualityInspectionId}
                clientId={clientId}
                interventionId={interventionId}
                orderId={orderId}
                onQuotationUpdated={onQuotationUpdated}
            />;
        }

        switch (qualityInspection.getCurrentStep()) {
            case QualityInspection.STEP_INITIALIZED:
                return <StepAppointment
                    qualityInspectionId={qualityInspectionId}
                    clientId={clientId}
                    interventionId={interventionId}
                    orderId={orderId}
                />;
            case QualityInspection.STEP_APPOINTMENT:
                return <StepTravel
                    qualityInspectionId={qualityInspectionId}
                    clientId={clientId}
                    interventionId={interventionId}
                    orderId={orderId}
                />;
            case QualityInspection.STEP_TRAVEL:
                return <StepPictureBefore
                    qualityInspectionId={qualityInspectionId}
                    clientId={clientId}
                    interventionId={interventionId}
                    orderId={orderId}
                />;
            case QualityInspection.STEP_PICTURE_BEFORE:
                return <StepQuotation
                    qualityInspectionId={qualityInspectionId}
                    clientId={clientId}
                    interventionId={interventionId}
                    orderId={orderId}
                />;
            case QualityInspection.STEP_QUOTATION:
                // Manual validation
                if (qualityInspection.getCurrentSubStep() === QualityInspection.SUB_STEP_ALL_TO_VALIDATE) {
                    return <SubStepToValidate
                        qualityInspectionId={qualityInspectionId}
                        clientId={clientId}
                        interventionId={interventionId}
                        orderId={orderId}
                    />;
                }

                return <StepClientSignature
                    qualityInspectionId={qualityInspectionId}
                    clientId={clientId}
                    interventionId={interventionId}
                    orderId={orderId}
                />;
            case QualityInspection.STEP_CLIENT_SIGNATURE:
                // Manual validation (when quotation updated)
                if (qualityInspection.getCurrentSubStep() === QualityInspection.SUB_STEP_ALL_TO_VALIDATE) {
                    return <SubStepToValidate
                        qualityInspectionId={qualityInspectionId}
                        clientId={clientId}
                        interventionId={interventionId}
                        orderId={orderId}
                    />;
                }

                // Client signature (when quotation updated)
                if (qualityInspection.getCurrentSubStep() === QualityInspection.SUB_STEP_ALL_VALIDATED) {
                    return <StepClientSignature
                        qualityInspectionId={qualityInspectionId}
                        clientId={clientId}
                        interventionId={interventionId}
                        orderId={orderId}
                    />;
                }

                return <StepWork
                    qualityInspectionId={qualityInspectionId}
                    clientId={clientId}
                    interventionId={interventionId}
                    orderId={orderId}
                />;
            case QualityInspection.STEP_WORK:
                return <StepPictureAfter
                    qualityInspectionId={qualityInspectionId}
                    clientId={clientId}
                    interventionId={interventionId}
                    orderId={orderId}
                />;
            case QualityInspection.STEP_PICTURE_AFTER:
                return <StepDelivery
                    qualityInspectionId={qualityInspectionId}
                    clientId={clientId}
                    interventionId={interventionId}
                    orderId={orderId}
                />;
            case QualityInspection.STEP_DELIVERY:
                return <Terminate
                    qualityInspectionId={qualityInspectionId}
                    clientId={clientId}
                    interventionId={interventionId}
                    orderId={orderId}
                />;
        }

        return "not found";
    }

    if (isNull(qualityInspection)) {
        return (
            <Box display="flex" justifyContent="center" mt={20}>
                <CircularProgress/>
            </Box>
        );
    }

    return getStep();
}